import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { OperacoesCard } from './components';
import { useOperacoesListagem, useOperacoesNavegacao } from './hooks';
import PageHeader from '@spark/ui-components/components/BreadCrumb';

const OperacoesMain = () => {
  const {
    data,
    loading,
    filterLoading,
    totalRegistros,
    handleFilterApply,
    handleExcluir
  } = useOperacoesListagem();
  const {
    handleRowClick,
    handleAdicionar,
    handleEditar
  } = useOperacoesNavegacao();
  return <Container fluid>
      <Row>
        <Col md={12}>
          <PageHeader title="" routeSegments={[{
          name: 'Início'
        }, {
          name: 'Operações'
        }]} />
        </Col>
      </Row>
      
      <Row>
        <Col md={12}>
          <OperacoesCard data={data} loading={loading} filterLoading={filterLoading} totalRegistros={totalRegistros} onFilterApply={handleFilterApply} onRowClick={handleRowClick} onAdicionar={handleAdicionar} />
        </Col>
      </Row>
    </Container>;
};

export default OperacoesMain;
